import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindVariants } from "@air/tailwind-variants";
import { Primitive } from "@radix-ui/react-primitive";
import { memo } from "react";
export const badge = tailwindVariants({
    base: "inline-flex items-center justify-between gap-1 font-bold uppercase tracking-wide transition-colors",
    variants: {
        appearance: {
            pill: "rounded-full",
            square: "rounded-2"
        },
        color: {
            blue: "bg-blue-8 text-blue-1",
            grey: "bg-grey-4 text-grey-10",
            "light-blue": "bg-blue-2 text-blue-9",
            red: "bg-red-10 text-red-1",
            teal: "bg-teal-2 text-teal-10",
            yellow: "bg-yellow-3 text-orange-11"
        },
        size: {
            small: "h-4 px-1.5 text-10",
            medium: "h-5 px-1.5 text-12"
        }
    },
    defaultVariants: {
        appearance: "square",
        color: "grey",
        size: "small"
    }
});
export const Badge = /*#__PURE__*/ memo((param)=>{
    let { appearance, className, color = "grey", size = "small", ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(Primitive.div, {
        className: badge({
            appearance,
            color,
            size,
            className
        }),
        ...restOfProps
    });
});
Badge.displayName = "Badge";
